import * as React from 'react';
import DocumentUpload from './DocumentUpload';
import ResumeUpload from './ResumeUpload';
import ProTip from './ProTip';

export default function Documents() {
  // Context is available if needed for future enhancements
  // const [state, dispatch] = React.useContext(ProfileFormContext);

  return (
    <div>
      <div className="form-section-card">
        <h3><i className="fas fa-file-alt"></i> Resume</h3>
        <ResumeUpload />
        <ProTip variant="green" icon="fas fa-file-upload">
          Keep your resume updated with your latest experience and certifications. PDF format is recommended for best compatibility.
        </ProTip>
      </div>
      <div className="form-section-card">
        <h3><i className="fas fa-folder-open"></i> Additional Documents</h3>
        <DocumentUpload />
        <ProTip variant="green" icon="fas fa-lightbulb">
          Upload your licenses, certifications, and other credentials here. Having these ready speeds up the verification process.
        </ProTip>
      </div>
    </div>
  );
}
